import { OrderErrorActivity, OrderActivity, Order } from '@tradingblock/types';
import _ from 'lodash';

export function isErrorActivity(act: OrderActivity | OrderErrorActivity | Order): act is OrderErrorActivity {
  const orderApiStatus = _.get(act, 'orderApiStatus', undefined);
  return orderApiStatus === 'error';
}
